import productContentRaw from './productContent.generated.json';

export type ProductLaunchContent = {
  sku: string;
  image: string;
  imageAlt: string;
  imageDisclosure: string;
  launchPrepStockQty: 1;
  launchPrepStockStatus: 'internal_launch_prep_not_public_stock';
  checkoutFlowStatus: 'blocked_until_checkout_ready';
  headline: string;
  intro: string;
  bullets: string[];
  objections: string[];
  primaryCta: string;
  secondaryCta: string;
};

type ProductContentPayload = {
  generatedAt: string;
  source: string;
  policy: string;
  count: number;
  products: ProductLaunchContent[];
};

export const productContent = productContentRaw as ProductContentPayload;
export const productContentBySku = new Map(productContent.products.map((item) => [item.sku, item]));

export function getProductLaunchContent(sku: string): ProductLaunchContent {
  const content = productContentBySku.get(sku);
  if (!content) {
    throw new Error(`Missing product launch content for SKU ${sku}`);
  }
  return content;
}
